// Shared helper for turning a paginated API response into the meta shape
// expected by the Pagination component.
export const transformToPaginationMeta = (apiResponse, pageSize) => {
  if (!apiResponse) return null;

  const {
    totalNumOfItems = 0,
    totalPages = 1,
    currentPage = 1,
  } = apiResponse;

  const perPage = pageSize || Math.ceil(totalNumOfItems / totalPages) || 10;
  const from = totalNumOfItems > 0 ? ((currentPage - 1) * perPage) + 1 : 0;
  const to = Math.min(currentPage * perPage, totalNumOfItems);

  return {
    current_page: currentPage,
    last_page: totalPages,
    from,
    to,
    total: totalNumOfItems,
    per_page: perPage,
  };
};
